<template>
  <div>
    <el-select
      v-model="statusSelected"
      size="mini"
      placeholder="Status"
      @change="OnStatusSelected"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  data() {
    return {
      statusSelected: 0,
      options: [
        { label: "Todas", value: 0 },
        { label: "Asignadas", value: 1 },
        { label: "Sin Asignar", value: 3 },
        { label: "cerradas", value: 2 }
      ]
    };
  },
  methods: {
    OnStatusSelected(value) {
      this.$emit("StatusSelected", value);
    }
  }
};
</script>

<style></style>
